import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { productTypeAPI } from '../../api'

export const productTypeKeys = {
  all: ['product-types'] as const,
  byCategory: (category?: string, categoryId?: number) =>
    [...productTypeKeys.all, { category, categoryId }] as const,
}

export function useProductTypes(params?: { category?: string; category_id?: number; enabled?: boolean }) {
  const { enabled = true, ...queryParams } = params || {}
  return useQuery({
    queryKey: productTypeKeys.byCategory(queryParams.category, queryParams.category_id),
    queryFn: () => productTypeAPI.getProductTypes(queryParams),
    enabled,
  })
}

export function usePublicProductTypes(params?: { category?: string; enabled?: boolean }) {
  const { enabled = true, category } = params || {}
  return useQuery({
    queryKey: [...productTypeKeys.all, 'public', { category }] as const,
    queryFn: () => productTypeAPI.getPublicProductTypes({ category }),
    enabled,
  })
}

export function useCreateProductType() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: { name: string; category?: string; category_id?: number }) =>
      productTypeAPI.createProductType(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productTypeKeys.all })
    },
  })
}

export function useUpdateProductType() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: { name: string } }) =>
      productTypeAPI.updateProductType(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productTypeKeys.all })
    },
  })
}

export function useDeleteProductType() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => productTypeAPI.deleteProductType(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productTypeKeys.all })
    },
  })
}
